import { apiClient } from "shared/utils";
import { CheckHashResponse, CheckHashRequest } from "api/models";

export const postCheckResetHash = async (values: CheckHashRequest) => {
  const { data } = await apiClient.post<CheckHashResponse>("user/password/validate-link", values);

  return data;
};
